/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 適用中のプランを更新する際にPOSTするBody
 * @export
 * @interface ExtendApplyingPlanBody
 */
export interface ExtendApplyingPlanBody {
    /**
     * 自動更新するか
     * @type {boolean}
     * @memberof ExtendApplyingPlanBody
     */
    isEnableAutoRenewable: boolean;
    /**
     * 一括請求か
     * @type {boolean}
     * @memberof ExtendApplyingPlanBody
     */
    isEnableLumpSumPayment: boolean;
}

export function ExtendApplyingPlanBodyFromJSON(json: any): ExtendApplyingPlanBody {
    return ExtendApplyingPlanBodyFromJSONTyped(json, false);
}

export function ExtendApplyingPlanBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtendApplyingPlanBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isEnableAutoRenewable': json['is_enable_auto_renewable'],
        'isEnableLumpSumPayment': json['is_enable_lump_sum_payment'],
    };
}

export function ExtendApplyingPlanBodyToJSON(value?: ExtendApplyingPlanBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_enable_auto_renewable': value.isEnableAutoRenewable,
        'is_enable_lump_sum_payment': value.isEnableLumpSumPayment,
    };
}

